"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Users/Admin/View/tabs/Assignments.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Locale_template = require("../../../../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_attrs0 = {
        style: "height:30vh",
        "class": "d-flex align-items-center justify-content-center"
      };

function render(input, out, __component, component, state) {
  var data = input;

  if (Array.isArray(input.assignments) && input.assignments.length) {} else {
    out.be("div", marko_attrs0, "0", component);

    Locale_tag({
        text: "No Assignment",
        class: "text-muted"
      }, out, __component, "1");

    out.ee();
  }
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
